import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
export const LeftTitle = styled.span `
  margin-right: 10px;
`;
export const RightTitle = styled.span `
  margin-left: 10px;
`;
const Wrapper = styled.div `
  display: flex;
  align-items: center;
  height: 38px;
  margin: 0;
  cursor: pointer;
`;
const Group = ({ leftTitle, rightTitle, children }) => (_jsxs(Wrapper, { children: [leftTitle && _jsx(LeftTitle, { children: leftTitle }), children, rightTitle && _jsx(RightTitle, { children: rightTitle })] }));
export default Group;
